define('extensions/knockout/fp_toggles_visible',[], function () {

    ko.bindingHandlers["fp_toggles_visible"] = {
        update: function(element, valueAccessor, allBindingsAccessor, viewModel) {
            var unwrap = ko.utils.unwrapObservable;
            var togglesVisible = unwrap(valueAccessor());
            
            var toggles = $("#toggle-navigation-hotspot, #toggle-details-hotspot", element);
            if (togglesVisible === true) {
                toggles.show();
            } else {
                toggles.hide();
            }
            if (togglesVisible === true) {
                $("div.navbar-header.pull-left:first", element).addClass("toggle-visible");
                $("div.navbar-header.pull-right:first", element).addClass("toggle-visible");
            }
            else {
                $("div.navbar-header.pull-left:first", element).removeClass("toggle-visible");
                $("div.navbar-header.pull-right:first", element).removeClass("toggle-visible");
            }


        }
    };

});
